<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Image Gallery</h5>
                  </div>
                  <small class="text-truncate text-muted">Fillter bootstrap image gallery</small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container px-0">

          <div class="row">
            <div class="col-12 mb-4">
              <button class="btn btn-default filter-button ml-1" (click)="all()">All</button>
              <button class="btn btn-default filter-button ml-1" (click)="hdpepipe()">HDPE Pipes</button>
              <button class="btn btn-default filter-button ml-1" (click)="sprinkle()">Sprinkle
                Pipes</button>
              <button class="btn btn-default filter-button ml-1" (click)="spary()">Spray
                Nozzle</button>
              <button class="btn btn-default filter-button ml-1" (click)="irrigation()">Irrigation
                Pipes</button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6" *ngIf="hd">
              <div class="card mb-4">
                <img src="assets/images/gallery/1.jpg" class="img-fluid img-thumbnail">
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6" *ngIf="sprink">
              <div class="card mb-4">
                <img src="assets/images/gallery/2.jpg" class="img-fluid img-thumbnail">
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6" *ngIf="hd">
              <div class="card mb-4">
                <img src="assets/images/gallery/3.jpg" class="img-fluid img-thumbnail">
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6" *ngIf="irrigatio">
              <div class="card mb-4">
                <img src="assets/images/gallery/4.jpg" class="img-fluid img-thumbnail">
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6" *ngIf="spy">
              <div class="card mb-4">
                <img src="assets/images/gallery/5.jpg" class="img-fluid img-thumbnail">
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6" *ngIf="irrigatio">
              <div class="card mb-4">
                <img src="assets/images/gallery/6.jpg" class="img-fluid img-thumbnail">
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6" *ngIf="spy">
              <div class="card mb-4">
                <img src="assets/images/gallery/7.jpg" class="img-fluid img-thumbnail">
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 " *ngIf="irrigatio">
              <div class="card mb-4">
                <img src="assets/images/gallery/8.jpg" class="img-fluid img-thumbnail">
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6" *ngIf="irrigatio">
              <div class="card mb-4">
                <img src="assets/images/gallery/9.jpg" class="img-fluid img-thumbnail">
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6" *ngIf="hd">
              <div class="card mb-4">
                <img src="assets/images/gallery/10.jpg" class="img-fluid img-thumbnail">
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6" *ngIf="sprink">
              <div class="card mb-4">
                <img src="assets/images/gallery/1.jpg" class="img-fluid img-thumbnail">
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6" *ngIf="spy">
              <div class="card mb-4">
                <img src="assets/images/gallery/1.jpg" class="img-fluid img-thumbnail">
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
